/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import "./StepNumber.scss";
import { cn } from "tailwind-variants";

export default function StepNumber({
  content,
  stepNumber = 1,
  showTopBorder = false,
  compact = false,
  children,
  ...restProps
}: any) {
  return (
    <div
      {...restProps}
      className={cn(
        "step-number scope-81d5256b",
        {
          "step-number--with-line": showTopBorder,
          "step-number--compact": compact
        },
        restProps.className
      )}
    >
      <div className="step-number__content scope-81d5256b">
        {" "}
        Step {stepNumber}:{" "}
        <span className="step-number__content--light scope-81d5256b">{content}</span>
      </div>
      {children}
    </div>
  );
}
